import { CheckCircleIcon, XCircleIcon } from '@phosphor-icons/react'

import { contrastRatioAA, sRgbLinearThreshold } from './constants'

const expandShorthandHex = hex => hex.replace(/^#?([\da-f])([\da-f])([\da-f])$/i, '$1$1$2$2$3$3')

const parseHexColor = color => {
  if (!color) return null

  const hex = expandShorthandHex(color).replace('#', '')

  if (!/^[\da-f]{6}$/i.test(hex)) return null

  return [0, 2, 4].map(offset => parseInt(hex.slice(offset, offset + 2), 16) / 255)
}

const getChannelLuminance = channel => {
  if (channel <= sRgbLinearThreshold) return channel / 12.92

  return ((channel + 0.055) / 1.055) ** 2.4
}

const getRelativeLuminance = channels => {
  const [red, green, blue] = channels.map(getChannelLuminance)

  return 0.2126 * red + 0.7152 * green + 0.0722 * blue
}

export const getContrastRatio = (color, otherColor) => {
  const channels = parseHexColor(color)
  const otherChannels = parseHexColor(otherColor)

  if (!channels || !otherChannels) return null

  const luminance = getRelativeLuminance(channels)
  const otherLuminance = getRelativeLuminance(otherChannels)

  return (Math.max(luminance, otherLuminance) + 0.05) / (Math.min(luminance, otherLuminance) + 0.05)
}

export const meetsContrastRatioAA = (color, otherColor) => {
  const ratio = getContrastRatio(color, otherColor)

  if (!ratio) return false

  return ratio >= contrastRatioAA
}

export const getContrastIndicator = (meetsAA, theme) => {
  if (meetsAA) {
    return { label: 'Ratio de contraste: cumple AA', color: theme.colors.success.default, Icon: CheckCircleIcon }
  }

  return { label: 'Ratio de contraste: no cumple AA', color: theme.colors.danger.default, Icon: XCircleIcon }
}
